var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.043 13.125H5.48047C5.24848 13.1248 5.02605 13.0325 4.86201 12.8685C4.69796 12.7044 4.6057 12.482 4.60547 12.25V9.625H5.48047V12.25H12.043V2.625H8.10547V1.75H12.043C12.275 1.75023 12.4974 1.84249 12.6614 2.00654C12.8255 2.17058 12.9177 2.39301 12.918 2.625V12.25C12.9177 12.482 12.8255 12.7044 12.6614 12.8685C12.4974 13.0325 12.275 13.1248 12.043 13.125Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 4.375H11.168V5.25H8.10547V4.375ZM7.66797 6.5625H11.168V7.4375H7.66797V6.5625ZM7.23047 8.75H11.168V9.625H7.23047V8.75ZM4.60547 8.3125C4.02549 8.31192 3.46942 8.08127 3.05931 7.67116C2.6492 7.26105 2.41855 6.70498 2.41797 6.125V1.3125H3.29297V6.125C3.29297 6.4731 3.43125 6.80694 3.67739 7.05308C3.92353 7.29922 4.25737 7.4375 4.60547 7.4375C4.95357 7.4375 5.28741 7.29922 5.53355 7.05308C5.77969 6.80694 5.91797 6.4731 5.91797 6.125V2.1875C5.91797 2.07147 5.87188 1.96019 5.78983 1.87814C5.70778 1.79609 5.5965 1.75 5.48047 1.75C5.36444 1.75 5.25316 1.79609 5.17111 1.87814C5.08906 1.96019 5.04297 2.07147 5.04297 2.1875V6.5625H4.16797V2.1875C4.16797 1.8394 4.30625 1.50556 4.55239 1.25942C4.79853 1.01328 5.13237 0.875 5.48047 0.875C5.82857 0.875 6.16241 1.01328 6.40855 1.25942C6.65469 1.50556 6.79297 1.8394 6.79297 2.1875V6.125C6.79239 6.70498 6.56174 7.26105 6.15163 7.67116C5.74152 8.08127 5.18545 8.31192 4.60547 8.3125Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b467b5c21dc7a6a9b7c78b73c10f9a37.svg";
export { ForwardRef as ReactComponent };